import { withAntePostBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/antePostBased';

import type { SportsAntePostMarketState } from './types';

export const defaultState = withAntePostBasedMarketTemplateModelState<SportsAntePostMarketState>({
  isLoading: false,
  hasPreloaded: false,
  templates: []
});
